export default __webpack_public_path__ + "static/door-a4cbb2ab22e40ae6b9b2f585c431c2a7.png";